module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pt-2",
    attrs: {
      "id": "account-setup"
    }
  }, [_c('h3', {
    staticClass: "mb-2 pb-2"
  }, [_vm._v("Set up your XMission account")]), _vm._v(" "), _c('form-validator', {
    ref: "form",
    model: {
      value: (_vm.customerFormValid),
      callback: function($$v) {
        _vm.customerFormValid = $$v
      },
      expression: "customerFormValid"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('xm-input', {
    ref: "fname",
    staticClass: "signup-input",
    attrs: {
      "name": "fname",
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.fname),
      callback: function($$v) {
        _vm.fname = $$v
      },
      expression: "fname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('xm-input', {
    ref: "lname",
    staticClass: "signup-input",
    attrs: {
      "name": "lname",
      "label": "Last name",
      "required": ""
    },
    model: {
      value: (_vm.lname),
      callback: function($$v) {
        _vm.lname = $$v
      },
      expression: "lname"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('xm-input', {
    ref: "email",
    staticClass: "signup-input",
    attrs: {
      "name": "email",
      "label": "Email",
      "type": "email",
      "pattern": _vm.regex.email,
      "error": "Please enter a valid email address",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    ref: "phone",
    staticClass: "signup-input",
    attrs: {
      "name": "phone",
      "label": "Phone number",
      "type": "tel",
      "error": "Please enter a valid phone number",
      "pattern": _vm.regex.phone,
      "required": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("\n                  Date of birth\n                  "), _c('span', {
    staticClass: "btn-primary qtip",
    attrs: {
      "data-content": "For more secure account verification you can enter a 'security date' instead."
    }
  }, [_vm._v("?")])]), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    ref: "dob",
    staticClass: "signup-input",
    attrs: {
      "name": "dob",
      "pattern": _vm.dobPattern,
      "placeholder": "MM/DD/YYYY",
      "error": "Please enter a valid date of birth",
      "required": ""
    },
    model: {
      value: (_vm.dob),
      callback: function($$v) {
        _vm.dob = $$v
      },
      expression: "dob"
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('account-credentials')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerFormValid),
      expression: "customerFormValid"
    }],
    attrs: {
      "id": "account-credentials"
    }
  }, [_c('h4', {
    staticClass: "mt-3"
  }, [_vm._v("XMission account credentials")]), _vm._v(" "), _c('user-form', {
    on: {
      "form-valid": function($event) {
        _vm.userFormValid = true
      },
      "form-invalid": function($event) {
        _vm.userFormValid = false
      }
    },
    model: {
      value: (_vm.user_form),
      callback: function($$v) {
        _vm.user_form = $$v
      },
      expression: "user_form"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc434e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/CustomerSignupForm.vue
// module id = 1319
// module chunks = 16